import React from 'react'

import TableHeader from './header'
import Row from './row'
import './list.css'
import './table-column-sizes.css'
import ReactTooltip from 'react-tooltip'

export default ({
    editMode,
    list,
    loading,
    onchange,
    filter,
    onFilterChange,
    sort,
    sortOrder,
    onadd,
    onBulkCreate,
    onSave,
    onRemove,
    partners,
    dmps,
    dmpProducts,
    hasNewRows,
    offset,
    size,
    onLoadMore,
}) => {
    let node = null

    //console.log('partners', partners)
    node = (
        <div style={{
            'border': '1px solid #ddd',
            'padding': '20px'

        }}>
            
            <div className="row" style={{ marginTop: '20px' }}>
                {editMode && (
                    
                    <div className="col text-right">
                        <div className="">
                            <ReactTooltip id="saveBtnTooltip" type="dark" effect="solid">
                                <span>Save Revenue Share</span>
                            </ReactTooltip>
                            <ReactTooltip id="deleteBtnTooltip" type="dark" effect="solid">
                                <span>Delete Revenue Share</span>
                            </ReactTooltip>
                            
                            <button disabled={hasNewRows} onClick={() => onadd()} className="border-button inlinebuttons">
                                New 
                            </button>
                            &#160;
                            <button onClick={() => onBulkCreate()} className="border-button inlinebuttons">
                                Bulk Create
                            </button>
                        </div>
                    </div>
                )}
            </div>


            <table className="license-list license-list--table">
                <TableHeader editMode={editMode} sort={sort} sortOrder={sortOrder} />
                <tbody>
                    {list.map((r, index) => (
                        <Row
                            editMode={editMode}
                            partners={partners}
                            dmps={dmps}
                            dmpProducts={dmpProducts}
                            index={index}
                            onchange={onchange}
                            onSave={onSave}
                            onRemove={onRemove}
                            key={index}
                            row={r}
                        />
                    ))}
                    {!loading && list.length >= offset + size && (

                        <tr>
                            <td colSpan={8} style={{ textAlign: 'center' }}>
                                <button type="button" className="btn btn-link property-list property-list--load-more-button" onClick={onLoadMore}>
                                    Load more
                                    </button>
                            </td>
                        </tr>

                    )}
                    {loading && (
                        <tr>
                            <td colSpan={8} style={{ textAlign: 'center' }}>
                                <button type="button" className="btn btn-link property-list property-list--load-more-button" disabled>
                                    Loading...
                                    </button>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )


    return node
}
